module.exports = __webpack_public_path__ + "static/img/ponto-frio.bbe565c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ponto-frio.png
// module id = 236
// module chunks = 6